import { post, read } from '@/utils/request'
import type { DetailWithLogs, ListData } from 'bv-typings'

export type ReviewGoogleAccountInfo = {
  id: string // 数据Id
  applyId: string // 申请id
  accountNum: number // 开户数量
  isUrgent: number // 是否加急
  settlement: string // 结算主体
  subject: string // 开户主体
  currency: number // 币种
  customerType: number // 客户类型
  secondaryAgencyName: string // 二代名称
  industry: number // 行业类型
  productLinks: string // []产品链接
  timeZone: string // 时区
  sale: string // 负责销售
  applicant: string // 申请人
  applyTime: string // 申请开户时间
  pushStatus: number // 推送状态
  approver: string // 审批人
  approveTime: string // 审批时间
  customerNote: string // 客户备注
  applyStatus: number // 申请状态
  billingName: string
}

const baseUrl = 'gg_account_opening/approval_opening'

const getReviewList = (params: any, signal: any) => read<ListData<ReviewGoogleAccountInfo>>(
  baseUrl, params, undefined, undefined, { signal },
)

const exportReviewList = (params: any, signal: any) => read<ListData<ReviewGoogleAccountInfo>>(
  baseUrl, { ...params, export: 1 }, undefined, undefined, { signal },
)

type ReviewGoogleAccountDetail = DetailWithLogs<{
  id: string
  settlement: string
  ourCompany: number
  paymentMethod: number
  ae: string
  deliveryArea: number[]
  accounts: string[]
}>

const getReviewDetail = (id: string) => read<ReviewGoogleAccountDetail>(
  'gg_account_opening/full_opening',
  undefined,
  '获取详情失败', id,
)


const batchReject = (params: { ids: string[], rejectReason: string }) => post(
  'gg_account_opening/batch_reject',
  params,
  '批量驳回失败',
)

const batchReview = (params: { ids: string[], mcc: string }) => post(
  'gg_account_opening/batch_approval',
  params,
  '批量审批失败',
)

const batchManual = (params: { id: string, accounts: string[] }[]) => {
  
  return post(
    'gg_account_opening/handle_account_opening',
    Object.keys(params)?.map(item => ({ id: item, accounts: params[item] })),
    '手动下户失败',
  )
}

export {
  exportReviewList,
  getReviewList,
  getReviewDetail,
  batchReject,
  batchReview,
  batchManual,
}
